import { Flex } from '@chakra-ui/react'
import { iCompetenciaPDI } from '../../../../../interfaces'

interface iRecomendacaoProps{
  pos: number
  recomendacao: iCompetenciaPDI
  hFull?: boolean
}

export const ItemATrabalhar: React.FC<iRecomendacaoProps> = ({ recomendacao, pos, hFull }) => {
  return (
        <Flex width={'100%'} boxShadow={'var(--SombraBackground)'} height={hFull ? 'full' : '5.5rem'}>
            <Flex borderBottomLeftRadius={'.25rem'} borderTopLeftRadius={'.25rem'} background={'var(--c3)'} pos={'relative'}>
                <h3 style={{ position: 'absolute', top: '2px', left: '6px', fontSize: '1.25rem' }}>{pos}°</h3>
                <Flex width={'10rem'} textAlign={'center'} justifyContent={'center'} alignItems='center' flexDir={'column'} padding={'.5rem'} fontSize={'.8325rem'}>
                    <Flex width={'3.5rem'}>
                        <img style={{ width: '100%', height: '100%' }} src={recomendacao.avatar} />
                    </Flex>
                </Flex>
            </Flex>
            <Flex flexDir={'column'} borderBottomRightRadius={'.25rem'} borderTopRightRadius={'.25rem'} padding={'1rem'} color='white' fontWeight={'600'} background={'var(--Azul)'} justifyContent={'center'} width={'-webkit-fill-available'} fontSize={'.925rem'}>
                <strong>{recomendacao.nome?.replace('/', ' / ')}</strong>
            </Flex>
        </Flex>
  )
}
